import React, { useState } from 'react';
import { getBaseUrl, setBaseUrl, getDefaultBaseUrl } from '../config';
import { useToast } from './Toast';

const parseBaseUrl = (baseUrl) => {
  try {
    const u = new URL(baseUrl);
    return {
      protocol: u.protocol,
      host: u.hostname,
      port: u.port || (u.protocol === 'https:' ? '443' : '80')
    };
  } catch {
    return { protocol: 'http:', host: 'localhost', port: '4125' };
  }
};

const ServerUrl = ({ onSave }) => {
  const current = getBaseUrl();
  const parsed = parseBaseUrl(current);

  const [protocol, setProtocol] = useState(parsed.protocol);
  const [host, setHost] = useState(parsed.host);
  const [port, setPort] = useState(parsed.port);
  const showToast = useToast();

  const handleSave = () => {
    const url = `${protocol}//${host.trim()}:${port.trim()}`;
    setBaseUrl(url);
    showToast(`Server URL updated to ${url}`, 'success');
    if (onSave) onSave();
  };

  const handleReset = () => {
    setBaseUrl(getDefaultBaseUrl());
    const d = parseBaseUrl(getDefaultBaseUrl());
    setProtocol(d.protocol);
    setHost(d.host);
    setPort(d.port);
    showToast(`Server URL reset to ${getDefaultBaseUrl()}`, 'success');
    if (onSave) onSave();
  };

  return (
    <div className="box" style={{ maxWidth: '500px' }}>
      <h2 className="title is-4">Server URL</h2>
      <p className="mb-3">
        Specify the base URL and port used to reach the Injee server. This applies
        across the whole app.
      </p>

      <div className="field">
        <label className="label">Protocol</label>
        <div className="control">
          <div className="select">
            <select value={protocol} onChange={(e) => setProtocol(e.target.value)}>
              <option value="http:">http</option>
              <option value="https:">https</option>
            </select>
          </div>
        </div>
      </div>

      <div className="field">
        <label className="label">URL</label>
        <div className="control">
          <input
            className="input"
            type="text"
            placeholder="localhost"
            value={host}
            onChange={(e) => setHost(e.target.value)}
          />
        </div>
      </div>

      <div className="field">
        <label className="label">Port</label>
        <div className="control">
          <input
            className="input"
            type="text"
            placeholder="4125"
            value={port}
            onChange={(e) => setPort(e.target.value)}
          />
        </div>
      </div>

      <div className="field is-grouped">
        <div className="control">
          <button className="button is-primary" onClick={handleSave}>
            Save
          </button>
        </div>
        <div className="control">
          <button className="button is-light" onClick={handleReset}>
            Reset to default
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServerUrl;
